import Inputmask from "inputmask";

export const phoneInputMaskInit = (root = document) => {
    const inputs = root.querySelectorAll(".site-input--phone");

    if (!inputs.length) return;

    inputs.forEach((input) => {
        Inputmask.default({
            mask: "+\\9\\9\\8 99 999-99-99",
            placeholder: "_",
            showMaskOnFocus: true,
            clearMaskOnLostFocus: false,
        }).mask(input);
    });
};